export default {"src":"/_next/static/media/recommended.9f826366.svg","height":24,"width":97,"blurWidth":0,"blurHeight":0};